import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {prjId, sVer} = map.data
        const {bdCode, bdName, bdNo, pkid: bdId} = map.root.data

        openWindow(
            '/Ai',

            {
                bizMap: {bdCode, bdId, bdName, bdNo},
                prjId,
                scene: 'CODE_RCI',
                sVer,
                title: `程序模块: ${bdName}`,
            }
        )
    }

    return {
        label: '验收源码',
        onClick,
        ...props,
    }
}
